module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-03.2cd3e7f8.jpeg";